module.exports = __webpack_public_path__ + "img/icon1.8f7f211b.svg";